import { render, staticRenderFns } from "./ItemImageCarousel.vue?vue&type=template&id=5285279e&"
import script from "./ItemImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ItemImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JVolke\\Documents\\plentyDevTool\\38722\\18\\KrauseSohn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5285279e')) {
      api.createRecord('5285279e', component.options)
    } else {
      api.reload('5285279e', component.options)
    }
    module.hot.accept("./ItemImageCarousel.vue?vue&type=template&id=5285279e&", function () {
      api.rerender('5285279e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/ItemImageCarousel.vue"
export default component.exports